/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
import { win } from "@gr-common/head/namespaces";
export * from "../lib/nexus/index.js";
/*                                                             */
/*                                    */
import * as defines from "@gr-common/head/nexus";
/*                                         */
export const defineEvent = defines.defineEvent;
/*                                         */
export const defineStore = defines.defineStore;
/*                                            */
export const defineFunction = defines.defineFunction;
/*                                             */
export const defineNamespace = defines.defineNamespace;
const forServer = /*           */ () => createProxy(createStore(name)[1], configAsync);
/**
 *
 */
/*                                            */
export const otto = import.meta.env.SSR ? forServer() : (win.otto ?? {});
